import { GET_CLOTHING_RECIPES_SUCCESS } from "../actionTypes";

const initialState = []

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_CLOTHING_RECIPES_SUCCESS: {
      const clothingRecipes = action.payload;

      if (!clothingRecipes){
        return {...state};
      }

      return [...state, ...action.payload]
    }

    default:
      return state;
  }
}
